export const PAGE_SIZE = 100;
export const BULK_REORDER_PAGES_LIMIT = 5;
